export default function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}


//////////////////
// WEBPACK FOOTER
// /srv/www/dexwebsiteebwp/web/app/themes/dexcollection/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
// module id = 3
// module chunks = 0